export default __webpack_public_path__ + "static/media/elo.513f458a.svg";